// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"ProtectedRoute_progressContainer__2fzF9","progressLabel":"ProtectedRoute_progressLabel__1waBT"};